import styled from "styled-components";
import Column from "./Column";
import Space from "./Space";
import Card from "./Card";
import DeviceListCard from "./DeviceListCard";
import { useEffect } from "react";
import GuideCard from "./GuideCard";
import { useDeviceList } from "./provider/DeviceListProvider";
import { useTranslation } from "react-i18next";
import { useLang } from "../context/LangContext";

function Home() {
  const { deviceId } = useDeviceList();
  const { t } = useTranslation();
  useEffect(() => {
    document.title = t("connect_device") + " - " + t("appName");
  }, [t]);
  return (
    <div className="flex flex-col items-center gap-2 px-4">
      <Space height="20px" />
      <div className="flex flex-row gap-[40px] items-start flex-wrap justify-center">
        <DeviceListCard />
        <GuideCard />
      </div>
      <Space height="20px" />
      <div className="flex flex-col w-full items-center justify-center md:absolute md:bottom-0">
        <p className="text-[14px] pt-[8px] text-secondary">{t("your_id")}</p>
        <p className="text-[14px] pt-[4px] text-primary">{deviceId}</p>
        <Space height="20px" />
      </div>
    </div>
  );
}

export default Home;
